//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action

import * as guideAction from '../action/guideAction';

//Material-ui
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

//Icon

import CloseIcon from '@material-ui/icons/Close';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


class Comp extends React.Component {

	render() {

		return (
      <Dialog
        fullScreen
        open={this.props.guide.approachMail.visible}
        onClose={ () => this.props.guideApproachMailSet(false) }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%',zIndex:'100'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              無料メールご案内
            </div>
            <div>
              <IconButton onClick={ () => this.props.guideApproachMailSet(false, null) }>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>

        <DialogContent style={{padding:'10px'}}>
          <div>
            <div style={{margin:'15px'}} align='center'>
              <div className='round12 shadow' style={{background:'#A6BDD5', maxWidth:'560px'}}>
                <div style={{padding:'10px'}}>
                  <div style={{fontSize:'1.6em', fontWeight:'bold', color:'#073E77'}} align='center'>無料メールとは</div>

                  <div style={{margin:'3px',textAlign:'left'}}>
                    <ul style={{margin:'5px 5px 5px 25px',color:'#333'}}>
                      <li>無料メールはお相手１人につき最大５通まで(各証明書を申請される毎に上限が増えます)送ることができます。</li>
                      <li>無料メールは最大100文字で、ガイドラインチェック後に送信されます。</li>
                      <li>連絡先の交換は行えません。</li>
                    </ul>
                  </div>

                  <div style={{margin:'15px',textAlign:'left'}}>
                    <div style={{fontSize:'0.9em',color:'#333'}}>
                      無料メールでアプローチしてお返事があった際に、有料サービスにお申込みいただければ、無駄な費用が掛からずに活動いただけます。
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div style={{margin:'15px'}}>
              <div
                width='100%'
                style={{border:'1px solid #E5E5E5', background:'#FFF'}}
                className='comparison_table shadow'
              >

                <div className='tr'>
                  <div className='th' style={{width:'25%', minWidth:'100px'}}>
                  </div>
                  <div className='th' style={{width:'25%', background:'#A6BDD5', textAlign:'center', color:'#073E77'}}>
                    無料サービス
                  </div>

                </div>

                <div className='tr'>
                  <div className='td'>
                    お相手1人への送信数
                  </div>
                  <div className='td'>
                    <div style={{fontSize:'１em'}}>
                      <span className='i-b'>最大5通まで</span>
                    </div>
                  </div>
                </div>
                <div className='tr'>
                  <div className='td'>
                    お相手の人数
                  </div>
                  <div className='td'>
                    上限なし
                  </div>

                </div>
                <div className='tr'>
                  <div className='td'>
                    受信メールの閲覧
                  </div>
                  <div className='td'>
                    お相手からの返信メールも閲覧できます
                  </div>

                </div>

                <div className='tr'>
                  <div className='td'>
                    連絡先の交換
                  </div>
                  <div className='td'>
                    連絡先を含むメールは送受信できません
                  </div>

                </div>
              </div>

            </div>

          </div>
        </DialogContent>
      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		guide: state.guide,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
